import React from "react";

function CardScanned() {
  return <div className="cardScanned__base"></div>;
}

export default CardScanned;
